import { formatNumber } from "@/features/shared";
import Grid from "@mui/material/Grid";
import { DataGrid } from "@mui/x-data-grid";
import PropTypes from "prop-types";

const LensProductItem = ({ salesRequestProductVariants }) => {
  // Map to table rows
  const rows = salesRequestProductVariants.map((salesRequestProductVariant) => {
    const {
      id,
      purchaseOrderProductVariant: { side, sku, name, note, costPerUnit },
    } = salesRequestProductVariant;

    return {
      id,
      side,
      sku,
      name,
      note,
      price: costPerUnit ?? 0,
    };
  });

  const columns = [
    {
      field: "side",
      headerName: "Sisi",
      flex: 1,
      sortable: false,
    },
    {
      field: "sku",
      headerName: "SKU",
      flex: 3,
      sortable: false,
    },
    {
      field: "variant",
      headerName: "Varian",
      flex: 2,
      sortable: false,
      valueGetter: (_, row) => {
        // Get axis from note
        let axis = "-";
        try {
          const parsed = JSON.parse(row.note || "{}");
          axis = parsed.axis || "0";
        } catch {
          // Ignore JSON parse errors
        }

        // Parse prescription parts from name: {sph}/{cyl}/{add?}/{side?}
        const prescriptionParts = row.name
          ?.substring(row.name.lastIndexOf(" ") + 1)
          .split("/");
        const sph = prescriptionParts?.[0] || "-";
        const cyl = prescriptionParts?.[1] || "-";
        const add = prescriptionParts?.[2] || "0"; // Use "0" if null

        // Build prescription format: {sph}/{cyl}/{axis}/{add}
        return `${sph}/${cyl}/${axis}/${add}`;
      },
    },
    {
      field: "variantNote",
      headerName: "PD/Prism",
      flex: 1.5,
      sortable: false,
      valueGetter: (_, row) => {
        let pd = "-",
          prism = "-";

        try {
          const parsed = JSON.parse(row.note || "{}");
          pd = parsed.pd || "-";
          prism = parsed.prism || "-";
        } catch {
          // Ignore JSON parse errors
        }

        // Build format: {pd}/{prism}
        return `${pd}/${prism}`;
      },
    },
    {
      field: "price",
      headerName: "Harga",
      flex: 1,
      type: "number",
      sortable: false,
      valueFormatter: (value) => formatNumber(value),
    },
  ];

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12 }}>
        <DataGrid
          getRowHeight={() => "auto"}
          columns={columns}
          rows={rows}
          getRowId={(row) => row.id}
          disableRowSelectionOnClick
          hideFooter
        />
      </Grid>
    </Grid>
  );
};

LensProductItem.propTypes = {
  salesRequestProductVariants: PropTypes.array.isRequired,
};

export default LensProductItem;
